<template>
  <div class="option__fields">
    <div
      v-for="value in values"
      :key="value.code"
      class="option__field">

      <forms-radio
        :value="value.code"
        :name="id"
        v-model="choice"
        @change="propagate"
      >{{ value.name }}</forms-radio>

      <span 
        class="option__price"
        v-if="hasPriceVariation(value)">{{ priceVariationLabel(value.variationPrice) }}</span>

    </div>
  </div>
</template>

<script>
import isEmpty from '@/helpers/empty'
import OptionMixin from '@/modules/catalog/mixins/option'
import PriceMixin from '@/modules/catalog/mixins/price'

export default {
  name: 'ProductOptionMultipleChoice',

  mixins: [
    OptionMixin,
    PriceMixin
  ],

  computed: {
    price() {
      let ret = 0;
      if (this.values && this.values.length){

        this.values.forEach(v => {
          if (v.code === this.choice){
            let price = 0;

            price += !isEmpty(this.basePrice) ? this.basePrice : 0;
            price += !isEmpty(v.variationPrice) ? v.variationPrice : 0;
            
            ret = price;

          }
        })


        for (let i = 0; i < this.values.length; i++) {
          if (this.values[i].code === this.choice) {
            let price = 0;
            if (!isEmpty(this.basePrice)) {
              price += this.basePrice;
            }
            if (!isEmpty(this.values[i].price_variation)) {
              price += this.values[i].price_variation;
            }
            ret = price;
          }
        }
      }

      return ret;
    },

    valid() {
      return this.required ? this.choice !== null : true;
    },
  },

  created() {
    this.propagate();
  },
};
</script>
